module.exports = __webpack_public_path__ + "img/youtube.a8b6a1b4.svg";